import React, { type CSSProperties } from 'react';

import { X } from '@phosphor-icons/react';

import { cn } from '../utils/cn';

import type { MobileModalElementProps } from './MobileModalElement.types';

export function MobileModalElement({
  isOpen,
  onOpenChange,
  isLoading,
  children,
  showCloseButton,
  hideOverflow,
}: MobileModalElementProps) {
  const generatedStyle = {
    '--overlay-background-color': '#00000030',
    '--modal-close-button-color': undefined,
    '--modal-close-button-placement-top': '24px',
    '--modal-close-button-placement-right': '24px',
  } as CSSProperties;

  const contentRef = React.useRef<HTMLDivElement>(null);

  if (!isOpen) return null;

  return (
    <div
      aria-hidden={!isOpen}
      className={cn(
        'transition-opacity duration-200',
        'fixed',
        hideOverflow ? 'overflow-hidden' : 'overflow-scroll',
        'inset-0 z-50 bg-black/80',
        'bg-[--overlay-background-color]',
      )}
      style={generatedStyle}
    >
      <div ref={contentRef} className={cn('w-full bottom-0 left-0', 'bg-background')}>
        {showCloseButton && (
          <button
            type="button"
            onClick={() => {
              if (!isLoading) {
                onOpenChange?.(false);
              }
            }}
            className={cn(
              'z-50 absolute right-[--modal-close-button-placement-right] top-[--modal-close-button-placement-top] rounded-sm opacity-70',
              'hover:opacity-100 transition-opacity',
              'focus:outline-none focus:ring-2 focus:ring-offset-2',
              'text-[--modal-close-button-color]',
            )}
            aria-label="Close"
          >
            <X className="h-4 w-4" />
          </button>
        )}
        {children}
      </div>
    </div>
  );
}
